import AdminAddPaseinTreatment from "../../components/Admin/AdminTreatmentPasienAdd";

export default function AddPasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminAddPaseinTreatment/>
    </div>
  );
}
